import React, { useEffect, useState } from "react";
import "./hydrafacial.css";
import { useNavigate, Link, useLocation } from "react-router-dom";
import heroImage from "../../../assets/images/ad-acne.jpg";
import heroImage1 from "../../../assets/images/ad-acne1.jpg";
import favicon from "../../../assets/images/favicon.ico";

import deepCleansingIcon from "../../../assets/images/deep-cleansing.png";
import enhancedHydrationIcon from "../../../assets/images/enhanced-hydration.png";
import skinRenewalIcon from "../../../assets/images/skin-renewal.png";
import nonInvasiveIcon from "../../../assets/images/non-invasive.png";

// Import PNG icons for navigation treatments
import hydrafacialIcon from "../../../assets/images/botox.png";
import acneIcon from "../../../assets/images/navacne.png";
import skinBrighteningIcon from "../../../assets/images/skin-brightening.png";
import antiAgeingIcon from "../../../assets/images/anti-ageing.png";
import youthIcon from "../../../assets/images/youth.png";
import prpFaceIcon from "../../../assets/images/prpface.png";
import co2FacialIcon from "../../../assets/images/co2.png";
import acneScarIcon from "../../../assets/images/acnescar.png";
import moleBirthMarkIcon from "../../../assets/images/wart.png";
import tattoRemovalIcon from "../../../assets/images/tattoo.png";
import wartsRemovalIcon from "../../../assets/images/blackhead.png";
import antiAgeingLaserIcon from "../../../assets/images/laser.png";
import laserHairRemovalIcon from "../../../assets/images/laserHairRemoval.png";

const treatments = [
  { name: "ADVANCED HYDRAFACIAL" },
  { name: "ACNE" },
  { name: "ANTI AGEING" },
  { name: "YOUTH" },
  { name: "PRP FACE" },
  { name: "CO2 FACIAL" },
  { name: "ACNE SCAR" },
  { name: "MOLE & BIRTH MARK REMOVAL" },
  { name: "SKIN BRIGHTENING" },
  { name: "TATTO REMOVAL" },
  { name: "WARTS REMOVAL" },
  { name: "ANTI AGEING LASER" },
  { name: "LASER HAIR REMOVAL" },
];

// Mapping treatment names to their PNG icons
const treatmentIconPNGMap = {
  "ADVANCED HYDRAFACIAL": hydrafacialIcon,
  ACNE: acneIcon,
  "SKIN BRIGHTENING": skinBrighteningIcon,
  "ANTI AGEING": antiAgeingIcon,
  YOUTH: youthIcon,
  "PRP FACE": prpFaceIcon,
  "CO2 FACIAL": co2FacialIcon,
  "ACNE SCAR": acneScarIcon,
  "MOLE & BIRTH MARK REMOVAL": moleBirthMarkIcon,
  "TATTO REMOVAL": tattoRemovalIcon,
  "WARTS REMOVAL": wartsRemovalIcon,
  "ANTI AGEING LASER": antiAgeingLaserIcon,
  "LASER HAIR REMOVAL": laserHairRemovalIcon,
};

// Mapping treatment names to their URLs with "advanced" prefix
const treatmentUrlMap = {
  "ADVANCED HYDRAFACIAL": "/advanced-hydrafacial-treatment",
  "ACNE": "/advanced-acne-treatment",
  "ANTI AGEING": "/advanced-anti-ageing-treatment",
  "YOUTH": "/advanced-youth-treatment",
  "PRP FACE": "/advanced-prp-face-treatment",
  "CO2 FACIAL": "/advanced-co2-facial-treatment",
  "ACNE SCAR": "/advanced-acne-scar-treatment",
  "MOLE & BIRTH MARK REMOVAL": "/advanced-mole-birth-mark-removal-treatment",
  "SKIN BRIGHTENING": "/advanced-skin-brightening-treatment",
  "TATTO REMOVAL": "/advanced-tatto-removal-treatment",
  "WARTS REMOVAL": "/advanced-warts-removal-treatment",
  "ANTI AGEING LASER": "/advanced-anti-ageing-laser-treatment",
  "LASER HAIR REMOVAL": "/advanced-laser-hair-removal-treatment",
};

// Location data for SEO purposes only
const locations = {
  tambaram: {
    name: "Tambaram",
    address: "Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram, Tambaram, Chennai, Tamil Nadu 600045",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Chromepet, Pallavaram, Perungalathur",
    popularServices: [
      "PRP Hair Treatment",
      "Dental Fillings",
      "Acne & Skin Lightening",
      "Root Canal and Smile Design"
    ],
    specialties: "Hair Restoration & Dental Procedures",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Tambaram+Chennai"
  },
  valasaravakkam: {
    name: "Valasaravakkam",
    address: "48, 1st Main Rd, Krishnamachari Nagar, Valasaravakkam, Chennai, Tamil Nadu 600116",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Porur, Alwarthirunagar, Virugambakkam",
    popularServices: [
      "Braces and Orthodontics",
      "GFC Hair Therapy",
      "Pigmentation & Skin Whitening",
      "Anxiety & PCOS Homeopathy Treatment"
    ],
    specialties: "Skin Treatments & Women's Health",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Valasaravakkam+Chennai"
  },
  gerugambakkam: {
    name: "Gerugambakkam",
    address: "Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony, Gerugambakkam, Chennai, Tamil Nadu 600128",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Kundrathur, Mangadu, Poonamallee",
    popularServices: [
      "Hair Loss Treatment",
      "Skin Problem Solutions",
      "Complete Dental Care",
      "Natural Homeopathy Treatment"
    ],
    specialties: "Complete Healthcare Solutions",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Gerugambakkam+Chennai"
  },
  jayanagar: {
    name: "Jayanagar Bangalore",
    address: "Jayanagar, Bengaluru, Karnataka 560069",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Koramangala, BTM Layout, JP Nagar, Banashankari, Basavanagudi, Wilson Garden, Lalbagh",
    popularServices: [
      "Advanced Acne Treatment",
      "Hydrafacial Therapy",
      "Anti-Aging Solutions",
      "Laser Hair Removal"
    ],
    specialties: "Advanced Skin & Dermatology Treatments",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Jayanagar+Bangalore"
  }
};

// Define the gallery images
const images = [
  {
    src: "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?q=80",
    alt: "Before and After Results",
  },
  {
    src: "https://images.unsplash.com/photo-1609840114035-3c981b782dfe?q=80",
    alt: "Acne Procedure Close-Up",
  },
  {
    src: "https://images.unsplash.com/photo-1606206522398-de3bd05b1615?q=80",
    alt: "Advanced Acne Equipment",
  },
];

function TreatmentNav() {
  const [activeTab, setActiveTab] = useState("ACNE");
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    const pathSegments = location.pathname.split("/");
    const treatmentPath = pathSegments[pathSegments.length - 1];
    
    const currentTreatment = Object.entries(treatmentUrlMap).find(
      ([name, url]) => url.includes(treatmentPath)
    );
    
    if (currentTreatment) {
      setActiveTab(currentTreatment[0]);
    }
  }, [location.pathname]);

  const renderTreatmentIcon = (name) => {
    return treatmentIconPNGMap[name] ? (
      <img
        src={treatmentIconPNGMap[name]}
        alt={name}
        style={{ width: "100px", height: "100px" }}
      />
    ) : null;
  };

  const handleCardClick = (name) => {
    setActiveTab(name);
    navigate(treatmentUrlMap[name]);
  };

  return (
    <div className="ads-treatment-nav-container">
      <h2>INNOVATIVE ACNE SOLUTIONS</h2>
      <div className="ads-treatment-nav-cards">
        {treatments.map(({ name }) => (
          <div
            key={name}
            className={`ads-treatment-nav-card ${activeTab === name ? "active" : ""}`}
            onClick={() => handleCardClick(name)}
          >
            <div className="ads-card-icon">
              {renderTreatmentIcon(name)}
            </div>
            <div className="ads-card-title">{name}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function Acne() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [visibleGalleryImages, setVisibleGalleryImages] = useState([0, 1, 2]);

  // SEO and document setup
  useEffect(() => {
    // Enhanced SEO title with specific location keywords
    document.title =
      "Best Acne Treatment in Chennai, Bangalore | Skin Treatment Clinic Tamil Nadu Karnataka - H-Cura Multispecialty";
    
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Best acne treatment in Chennai, Bangalore. Advanced skin care solutions for acne, scars, and skin rejuvenation. Professional dermatological services at H-Cura clinic locations across Chennai Tamil Nadu and Bangalore Karnataka including Tambaram, Valasaravakkam, Gerugambakkam, Jayanagar areas."
      );
    }
    
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "acne treatment Chennai, skin treatment Bangalore, acne clinic Tamil Nadu, dermatologist Karnataka, skin care Chennai Bangalore, acne specialist Tamil Nadu Karnataka, best skin clinic Chennai Bangalore, acne treatment near me, skin treatment Tambaram Valasaravakkam Gerugambakkam Jayanagar, dermatology clinic Chennai Bangalore, acne scar treatment Tamil Nadu Karnataka, pimple treatment Chennai Bangalore, skin specialist Chromepet Pallavaram Perungalathur Koramangala BTM Layout JP Nagar, advanced acne treatment Porur Alwarthirunagar Virugambakkam Banashankari Basavanagudi, laser acne treatment Kundrathur Mangadu Poonamallee Wilson Garden Lalbagh, hydrafacial Chennai Bangalore, CO2 facial Tamil Nadu Karnataka, PRP face treatment Chennai Bangalore, anti aging treatment Tambaram Jayanagar, skin brightening Valasaravakkam Koramangala, acne removal Gerugambakkam BTM Layout, blackhead treatment Chennai Bangalore, dermatologist near me Tamil Nadu Karnataka, skin clinic Chennai Bangalore, acne treatment Chennai Bangalore, facial treatment Tamil Nadu Karnataka, skin care specialist Chennai Bangalore, acne doctor Chennai Bangalore, skin treatment center Tamil Nadu Karnataka, dermatology Chennai Bangalore, skincare clinic Tamil Nadu Karnataka, acne therapy Chennai Bangalore, skin rejuvenation Tamil Nadu Karnataka, acne consultation Chennai Bangalore, skin analysis Tamil Nadu Karnataka, acne prevention Chennai Bangalore, skin health Tamil Nadu Karnataka, dermatological treatment Chennai Bangalore, cosmetic dermatology Tamil Nadu Karnataka, medical skincare Chennai Bangalore, professional acne treatment Tamil Nadu Karnataka, skin wellness Chennai Bangalore, dermatology services Tamil Nadu Karnataka, acne treatment Tambaram Gandhi Road Jayanagar, skin clinic Valasaravakkam Krishnamachari Nagar Koramangala, dermatologist Gerugambakkam Ramachandra Nagar BTM Layout, acne doctor Chromepet Pallavaram JP Nagar Banashankari, skin treatment Porur Alwarthirunagar Basavanagudi Wilson Garden, facial clinic Virugambakkam Kundrathur Lalbagh, laser treatment Mangadu Poonamallee Bangalore"
      );
    }

    // Add structured data for local business with specific locations
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "MedicalBusiness",
      "name": "H-Cura Multispeciality Clinic",
      "description": "Advanced acne and skin treatment clinic offering professional dermatological services across Chennai Tamil Nadu, Bangalore Karnataka, and Pondicherry",
      "url": "https://www.h-cura.com/advanced-acne-treatment",
      "telephone": "+91 88700 01377",
      "priceRange": "₹₹",
      "address": [
        {
          "@type": "PostalAddress",
          "streetAddress": "Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram",
          "addressLocality": "Tambaram",
          "addressRegion": "Chennai, Tamil Nadu",
          "postalCode": "600045",
          "addressCountry": "IN"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "48, 1st Main Rd, Krishnamachari Nagar",
          "addressLocality": "Valasaravakkam",
          "addressRegion": "Chennai, Tamil Nadu",
          "postalCode": "600116",
          "addressCountry": "IN"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony",
          "addressLocality": "Gerugambakkam",
          "addressRegion": "Chennai, Tamil Nadu",
          "postalCode": "600128",
          "addressCountry": "IN"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "Jayanagar",
          "addressLocality": "Jayanagar",
          "addressRegion": "Bengaluru, Karnataka",
          "postalCode": "560069",
          "addressCountry": "IN"
        }
      ],
      "areaServed": [
        {
          "@type": "State",
          "name": "Tamil Nadu"
        },
        {
          "@type": "State",
          "name": "Karnataka"
        },
        {
          "@type": "State",
          "name": "Pondicherry"
        },
        {
          "@type": "City",
          "name": "Chennai"
        },
        {
          "@type": "City",
          "name": "Bangalore"
        },
        {
          "@type": "City",
          "name": "Bengaluru"
        },
        {
          "@type": "City",
          "name": "Pondicherry"
        },
        {
          "@type": "City",
          "name": "Puducherry"
        },
        // Chennai Areas
        {
          "@type": "City",
          "name": "Tambaram"
        },
        {
          "@type": "City",
          "name": "Valasaravakkam"
        },
        {
          "@type": "City",
          "name": "Gerugambakkam"
        },
        {
          "@type": "City",
          "name": "Chromepet"
        },
        {
          "@type": "City",
          "name": "Pallavaram"
        },
        {
          "@type": "City",
          "name": "Perungalathur"
        },
        {
          "@type": "City",
          "name": "Porur"
        },
        {
          "@type": "City",
          "name": "Alwarthirunagar"
        },
        {
          "@type": "City",
          "name": "Virugambakkam"
        },
        {
          "@type": "City",
          "name": "Kundrathur"
        },
        {
          "@type": "City",
          "name": "Mangadu"
        },
        {
          "@type": "City",
          "name": "Poonamallee"
        },
        {
          "@type": "City",
          "name": "Selaiyur"
        },
        {
          "@type": "City",
          "name": "Chitlapakkam"
        },
        {
          "@type": "City",
          "name": "Ramapuram"
        },
        {
          "@type": "City",
          "name": "Mugalivakkam"
        },
        {
          "@type": "City",
          "name": "Nazarethpet"
        },
        {
          "@type": "City",
          "name": "Thirumazhisai"
        },
        {
          "@type": "City",
          "name": "T. Nagar"
        },
        {
          "@type": "City",
          "name": "Anna Nagar"
        },
        {
          "@type": "City",
          "name": "Velachery"
        },
        {
          "@type": "City",
          "name": "Adyar"
        },
        {
          "@type": "City",
          "name": "Mylapore"
        },
        {
          "@type": "City",
          "name": "Nungambakkam"
        },
        {
          "@type": "City",
          "name": "Guindy"
        },
        {
          "@type": "City",
          "name": "OMR"
        },
        {
          "@type": "City",
          "name": "ECR"
        },
        {
          "@type": "City",
          "name": "Thoraipakkam"
        },
        {
          "@type": "City",
          "name": "Sholinganallur"
        },
        {
          "@type": "City",
          "name": "Medavakkam"
        },
        {
          "@type": "City",
          "name": "Madipakkam"
        },
        {
          "@type": "City",
          "name": "Keelkattalai"
        },
        {
          "@type": "City",
          "name": "Vandalur"
        },
        {
          "@type": "City",
          "name": "Urapakkam"
        },
        {
          "@type": "City",
          "name": "Guduvanchery"
        },
        {
          "@type": "City",
          "name": "Chengalpattu"
        },
        {
          "@type": "City",
          "name": "Kanchipuram"
        },
        {
          "@type": "City",
          "name": "Avadi"
        },
        {
          "@type": "City",
          "name": "Ambattur"
        },
        {
          "@type": "City",
          "name": "Red Hills"
        },
        {
          "@type": "City",
          "name": "Thiruvallur"
        },
        {
          "@type": "City",
          "name": "Ponneri"
        },
        {
          "@type": "City",
          "name": "Gummidipoondi"
        },
        {
          "@type": "City",
          "name": "Tiruttani"
        },
        {
          "@type": "City",
          "name": "Arakkonam"
        },
        {
          "@type": "City",
          "name": "Vellore"
        },
        {
          "@type": "City",
          "name": "Koyambedu"
        },
        {
          "@type": "City",
          "name": "Arumbakkam"
        },
        {
          "@type": "City",
          "name": "Vadapalani"
        },
        {
          "@type": "City",
          "name": "Ashok Nagar"
        },
        {
          "@type": "City",
          "name": "KK Nagar"
        },
        {
          "@type": "City",
          "name": "West Mambalam"
        },
        {
          "@type": "City",
          "name": "Kodambakkam"
        },
        {
          "@type": "City",
          "name": "Saidapet"
        },
        {
          "@type": "City",
          "name": "Teynampet"
        },
        {
          "@type": "City",
          "name": "Alwarpet"
        },
        {
          "@type": "City",
          "name": "Royapettah"
        },
        {
          "@type": "City",
          "name": "Egmore"
        },
        {
          "@type": "City",
          "name": "Kilpauk"
        },
        {
          "@type": "City",
          "name": "Chetpet"
        },
        {
          "@type": "City",
          "name": "Purasawalkam"
        },
        {
          "@type": "City",
          "name": "Perambur"
        },
        {
          "@type": "City",
          "name": "Vyasarpadi"
        },
        {
          "@type": "City",
          "name": "Tondiarpet"
        },
        {
          "@type": "City",
          "name": "Washermanpet"
        },
        {
          "@type": "City",
          "name": "Royapuram"
        },
        {
          "@type": "City",
          "name": "Madhavaram"
        },
        {
          "@type": "City",
          "name": "Manali"
        },
        {
          "@type": "City",
          "name": "Ennore"
        },
        {
          "@type": "City",
          "name": "Thiruvottiyur"
        },
        // Bangalore Areas
        {
          "@type": "City",
          "name": "Jayanagar"
        },
        {
          "@type": "City",
          "name": "Koramangala"
        },
        {
          "@type": "City",
          "name": "BTM Layout"
        },
        {
          "@type": "City",
          "name": "JP Nagar"
        },
        {
          "@type": "City",
          "name": "Banashankari"
        },
        {
          "@type": "City",
          "name": "Basavanagudi"
        },
        {
          "@type": "City",
          "name": "Wilson Garden"
        },
        {
          "@type": "City",
          "name": "Lalbagh"
        },
        {
          "@type": "City",
          "name": "Indiranagar"
        },
        {
          "@type": "City",
          "name": "Whitefield"
        },
        {
          "@type": "City",
          "name": "Electronic City"
        },
        {
          "@type": "City",
          "name": "HSR Layout"
        },
        {
          "@type": "City",
          "name": "Marathahalli"
        },
        {
          "@type": "City",
          "name": "Bannerghatta Road"
        },
        {
          "@type": "City",
          "name": "Hebbal"
        },
        {
          "@type": "City",
          "name": "Yeshwantpur"
        },
        {
          "@type": "City",
          "name": "Rajajinagar"
        },
        {
          "@type": "City",
          "name": "Malleshwaram"
        },
        {
          "@type": "City",
          "name": "Sadashivanagar"
        },
        {
          "@type": "City",
          "name": "RT Nagar"
        },
        {
          "@type": "City",
          "name": "Yelahanka"
        },
        {
          "@type": "City",
          "name": "Kengeri"
        },
        {
          "@type": "City",
          "name": "Vijayanagar"
        },
        {
          "@type": "City",
          "name": "Nagarbhavi"
        },
        {
          "@type": "City",
          "name": "Majestic"
        },
        {
          "@type": "City",
          "name": "Chickpet"
        },
        {
          "@type": "City",
          "name": "Shivajinagar"
        },
        {
          "@type": "City",
          "name": "Commercial Street"
        },
        {
          "@type": "City",
          "name": "Brigade Road"
        },
        {
          "@type": "City",
          "name": "MG Road"
        },
        {
          "@type": "City",
          "name": "UB City"
        },
        {
          "@type": "City",
          "name": "Cunningham Road"
        },
        {
          "@type": "City",
          "name": "Richmond Road"
        },
        {
          "@type": "City",
          "name": "Residency Road"
        },
        {
          "@type": "City",
          "name": "Lavelle Road"
        },
        {
          "@type": "City",
          "name": "St. Marks Road"
        },
        {
          "@type": "City",
          "name": "Church Street"
        },
        {
          "@type": "City",
          "name": "Fraser Town"
        },
        {
          "@type": "City",
          "name": "Cox Town"
        },
        {
          "@type": "City",
          "name": "Benson Town"
        },
        {
          "@type": "City",
          "name": "Kammanahalli"
        },
        {
          "@type": "City",
          "name": "Kalyan Nagar"
        },
        {
          "@type": "City",
          "name": "HBR Layout"
        },
        {
          "@type": "City",
          "name": "Hennur"
        },
        {
          "@type": "City",
          "name": "Banaswadi"
        },
        {
          "@type": "City",
          "name": "Ramamurthy Nagar"
        },
        {
          "@type": "City",
          "name": "Lingarajapuram"
        },
        {
          "@type": "City",
          "name": "KR Puram"
        },
        {
          "@type": "City",
          "name": "Hoodi"
        },
        {
          "@type": "City",
          "name": "ITPL"
        },
        {
          "@type": "City",
          "name": "Varthur"
        },
        {
          "@type": "City",
          "name": "Sarjapur"
        },
        {
          "@type": "City",
          "name": "Bellandur"
        },
        {
          "@type": "City",
          "name": "Kadubeesanahalli"
        },
        {
          "@type": "City",
          "name": "Bagmane Tech Park"
        },
        {
          "@type": "City",
          "name": "Outer Ring Road"
        },
        {
          "@type": "City",
          "name": "Silk Board"
        },
        {
          "@type": "City",
          "name": "Bommanahalli"
        },
        {
          "@type": "City",
          "name": "Hongasandra"
        },
        {
          "@type": "City",
          "name": "Begur"
        },
        {
          "@type": "City",
          "name": "Hulimavu"
        },
        {
          "@type": "City",
          "name": "Arekere"
        },
        {
          "@type": "City",
          "name": "Bannerghatta"
        },
        {
          "@type": "City",
          "name": "Gottigere"
        },
        {
          "@type": "City",
          "name": "Konanakunte"
        },
        {
          "@type": "City",
          "name": "Anjanapura"
        },
        {
          "@type": "City",
          "name": "Kanakapura Road"
        },
        {
          "@type": "City",
          "name": "Uttarahalli"
        },
        {
          "@type": "City",
          "name": "Subramanyapura"
        },
        {
          "@type": "City",
          "name": "Girinagar"
        },
        {
          "@type": "City",
          "name": "Katriguppe"
        },
        {
          "@type": "City",
          "name": "Srinagar"
        },
        {
          "@type": "City",
          "name": "Padmanabhanagar"
        },
        {
          "@type": "City",
          "name": "Kumaraswamy Layout"
        },
        {
          "@type": "City",
          "name": "Vijaya Bank Layout"
        },
        {
          "@type": "City",
          "name": "Hosakerehalli"
        },
        {
          "@type": "City",
          "name": "Attiguppe"
        },
        {
          "@type": "City",
          "name": "Mysore Road"
        },
        {
          "@type": "City",
          "name": "Nayandahalli"
        },
        {
          "@type": "City",
          "name": "Rajarajeshwari Nagar"
        },
        {
          "@type": "City",
          "name": "Ideal Homes Township"
        },
        {
          "@type": "City",
          "name": "Chord Road"
        },
        {
          "@type": "City",
          "name": "Peenya"
        },
        {
          "@type": "City",
          "name": "Jalahalli"
        },
        {
          "@type": "City",
          "name": "Mathikere"
        },
        {
          "@type": "City",
          "name": "Sanjaynagar"
        },
        {
          "@type": "City",
          "name": "Dollar Layout"
        },
        {
          "@type": "City",
          "name": "MS Palya"
        },
        {
          "@type": "City",
          "name": "New Thippasandra"
        },
        {
          "@type": "City",
          "name": "Old Airport Road"
        },
        {
          "@type": "City",
          "name": "Domlur"
        },
        {
          "@type": "City",
          "name": "Ejipura"
        },
        {
          "@type": "City",
          "name": "Vivek Nagar"
        },
        {
          "@type": "City",
          "name": "Jeevan Bhima Nagar"
        },
        {
          "@type": "City",
          "name": "HAL"
        },
        {
          "@type": "City",
          "name": "Airport Road"
        },
        // Pondicherry Areas
        {
          "@type": "City",
          "name": "White Town"
        },
        {
          "@type": "City",
          "name": "Lawspet"
        },
        {
          "@type": "City",
          "name": "Mudaliarpet"
        },
        {
          "@type": "City",
          "name": "Villianur"
        },
        {
          "@type": "City",
          "name": "Bahour"
        },
        {
          "@type": "City",
          "name": "Oulgaret"
        },
        {
          "@type": "City",
          "name": "Ariyankuppam"
        },
        {
          "@type": "City",
          "name": "Manakula Vinayagar Temple"
        },
        {
          "@type": "City",
          "name": "Rock Beach"
        },
        {
          "@type": "City",
          "name": "Paradise Beach"
        },
        {
          "@type": "City",
          "name": "Serenity Beach"
        },
        {
          "@type": "City",
          "name": "Auroville"
        },
        {
          "@type": "City",
          "name": "Arikamedu"
        },
        {
          "@type": "City",
          "name": "Chunnambar"
        },
        {
          "@type": "City",
          "name": "Embalam"
        },
        {
          "@type": "City",
          "name": "Korkadu"
        },
        {
          "@type": "City",
          "name": "Kottakuppam"
        },
        {
          "@type": "City",
          "name": "Murungapakkam"
        },
        {
          "@type": "City",
          "name": "Nettapakkam"
        },
        {
          "@type": "City",
          "name": "Pillaiyarkuppam"
        },
        {
          "@type": "City",
          "name": "Polagam"
        },
        {
          "@type": "City",
          "name": "Sorapet"
        },
        {
          "@type": "City",
          "name": "Thengaithittu"
        },
        {
          "@type": "City",
          "name": "Thirubhuvanai"
        },
        {
          "@type": "City",
          "name": "Thirukameswaram"
        },
        {
          "@type": "City",
          "name": "Thirunallar"
        },
        {
          "@type": "City",
          "name": "Uppalam"
        },
        {
          "@type": "City",
          "name": "Vaithikuppam"
        },
        {
          "@type": "City",
          "name": "Karaikal"
        },
        {
          "@type": "City",
          "name": "Mahe"
        },
        {
          "@type": "City",
          "name": "Yanam"
        },
        {
          "@type": "City",
          "name": "French Quarter"
        },
        {
          "@type": "City",
          "name": "Tamil Quarter"
        },
        {
          "@type": "City",
          "name": "Mission Street"
        },
        {
          "@type": "City",
          "name": "MG Road Pondicherry"
        },
        {
          "@type": "City",
          "name": "Nehru Street"
        },
        {
          "@type": "City",
          "name": "Gandhi Thidal"
        },
        {
          "@type": "City",
          "name": "Goubert Avenue"
        },
        {
          "@type": "City",
          "name": "Beach Road"
        },
        {
          "@type": "City",
          "name": "Promenade Beach"
        },
        {
          "@type": "City",
          "name": "Bharathi Park"
        },
        {
          "@type": "City",
          "name": "Botanical Garden"
        },
        {
          "@type": "City",
          "name": "Sri Aurobindo Ashram"
        },
        {
          "@type": "City",
          "name": "Sacred Heart Church"
        },
        {
          "@type": "City",
          "name": "Immaculate Conception Cathedral"
        },
        {
          "@type": "City",
          "name": "Raj Nivas"
        },
        {
          "@type": "City",
          "name": "Government Park"
        },
        {
          "@type": "City",
          "name": "Pondicherry Museum"
        },
        {
          "@type": "City",
          "name": "Jawahar Toy Museum"
        },
        {
          "@type": "City",
          "name": "Romain Rolland Library"
        },
        {
          "@type": "City",
          "name": "Alliance Francaise"
        },
        {
          "@type": "City",
          "name": "Lycee Francais"
        },
        {
          "@type": "City",
          "name": "Ecole Francaise d'Extreme-Orient"
        },
        {
          "@type": "City",
          "name": "Ananda Rangam Pillai Road"
        },
        {
          "@type": "City",
          "name": "Kamban Road"
        },
        {
          "@type": "City",
          "name": "Lal Bahadur Shastri Street"
        },
        {
          "@type": "City",
          "name": "Perumal Koil Street"
        },
        {
          "@type": "City",
          "name": "Rangapillai Street"
        },
        {
          "@type": "City",
          "name": "Subbiah Salai"
        },
        {
          "@type": "City",
          "name": "Vysial Street"
        }
      ],
      "serviceArea": [
        // Tamil Nadu - Chennai Areas
        "Chennai", "Tamil Nadu", "Tambaram", "Valasaravakkam", "Gerugambakkam", "Chromepet", "Pallavaram", "Perungalathur",
        "Porur", "Alwarthirunagar", "Virugambakkam", "Kundrathur", "Mangadu", "Poonamallee", "Selaiyur", "Chitlapakkam",
        "Ramapuram", "Mugalivakkam", "Nazarethpet", "Thirumazhisai", "Gandhi Road", "Krishnamachari Nagar", "Ramachandra Nagar",
        "T. Nagar", "Anna Nagar", "Velachery", "Adyar", "Mylapore", "Nungambakkam", "Guindy", "OMR", "ECR", "Thoraipakkam",
        "Sholinganallur", "Medavakkam", "Madipakkam", "Keelkattalai", "Vandalur", "Urapakkam", "Guduvanchery", "Chengalpattu",
        "Kanchipuram", "Avadi", "Ambattur", "Red Hills", "Thiruvallur", "Ponneri", "Gummidipoondi", "Tiruttani", "Arakkonam",
        "Vellore", "Koyambedu", "Arumbakkam", "Vadapalani", "Ashok Nagar", "KK Nagar", "West Mambalam", "Kodambakkam",
        "Saidapet", "Teynampet", "Alwarpet", "Royapettah", "Egmore", "Kilpauk", "Chetpet", "Purasawalkam", "Perambur",
        "Vyasarpadi", "Tondiarpet", "Washermanpet", "Royapuram", "Madhavaram", "Manali", "Ennore", "Thiruvottiyur",
        
        // Karnataka - Bangalore Areas
        "Bangalore", "Bengaluru", "Karnataka", "Jayanagar", "Koramangala", "BTM Layout", "JP Nagar", "Banashankari", "Basavanagudi", "Wilson Garden", "Lalbagh",
        "Indiranagar", "Whitefield", "Electronic City", "HSR Layout", "Marathahalli", "Bannerghatta Road", "Hebbal", "Yeshwantpur",
        "Rajajinagar", "Malleshwaram", "Sadashivanagar", "RT Nagar", "Yelahanka", "Kengeri", "Vijayanagar", "Nagarbhavi",
        "Majestic", "Chickpet", "Shivajinagar", "Commercial Street", "Brigade Road", "MG Road", "UB City", "Cunningham Road",
        "Richmond Road", "Residency Road", "Lavelle Road", "St. Marks Road", "Church Street", "Fraser Town", "Cox Town",
        "Benson Town", "Kammanahalli", "Kalyan Nagar", "HBR Layout", "Hennur", "Banaswadi", "Ramamurthy Nagar", "Lingarajapuram",
        "KR Puram", "Hoodi", "ITPL", "Varthur", "Sarjapur", "Bellandur", "Kadubeesanahalli", "Bagmane Tech Park", "Outer Ring Road",
        "Silk Board", "Bommanahalli", "Hongasandra", "Begur", "Hulimavu", "Arekere", "Bannerghatta", "Gottigere", "Konanakunte",
        "Anjanapura", "Kanakapura Road", "Uttarahalli", "Subramanyapura", "Girinagar", "Katriguppe", "Srinagar", "Padmanabhanagar",
        "Kumaraswamy Layout", "Vijaya Bank Layout", "Hosakerehalli", "Attiguppe", "Mysore Road", "Nayandahalli", "Rajarajeshwari Nagar",
        "Ideal Homes Township", "Chord Road", "Peenya", "Jalahalli", "Mathikere", "Sanjaynagar", "Dollar Layout", "MS Palya",
        "New Thippasandra", "Old Airport Road", "Domlur", "Ejipura", "Vivek Nagar", "Jeevan Bhima Nagar", "HAL", "Airport Road",
        
        // Pondicherry Areas
        "Pondicherry", "Puducherry", "White Town", "Lawspet", "Mudaliarpet", "Villianur", "Bahour", "Oulgaret", "Ariyankuppam",
        "Manakula Vinayagar Temple", "Rock Beach", "Paradise Beach", "Serenity Beach", "Auroville", "Arikamedu", "Chunnambar",
        "Embalam", "Korkadu", "Kottakuppam", "Murungapakkam", "Nettapakkam", "Pillaiyarkuppam", "Polagam", "Sorapet", "Thengaithittu",
        "Thirubhuvanai", "Thirukameswaram", "Thirunallar", "Uppalam", "Vaithikuppam", "Karaikal", "Mahe", "Yanam", "French Quarter",
        "Tamil Quarter", "Mission Street", "MG Road Pondicherry", "Nehru Street", "Gandhi Thidal", "Goubert Avenue", "Beach Road",
        "Promenade Beach", "Bharathi Park", "Botanical Garden", "Sri Aurobindo Ashram", "Sacred Heart Church", "Immaculate Conception Cathedral",
        "Raj Nivas", "Government Park", "Pondicherry Museum", "Jawahar Toy Museum", "Romain Rolland Library", "Alliance Francaise",
        "Lycee Francais", "Ecole Francaise d'Extreme-Orient", "Ananda Rangam Pillai Road", "Kamban Road", "Lal Bahadur Shastri Street",
        "Perumal Koil Street", "Rangapillai Street", "Subbiah Salai", "Vysial Street"
      ],
      "medicalSpecialty": [
        "Dermatology",
        "Cosmetic Dermatology", 
        "Acne Treatment",
        "Skin Care",
        "Anti-Aging Treatment",
        "Laser Treatment",
        "Hydrafacial",
        "PRP Therapy"
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Skin Treatment Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure",
              "name": "Advanced Acne Treatment"
            }
          },
          {
            "@type": "Offer", 
            "itemOffered": {
              "@type": "MedicalProcedure",
              "name": "Hydrafacial Treatment"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "PRP Face Treatment"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "CO2 Facial Treatment"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Laser Hair Removal"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Anti-Aging Treatment"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Skin Brightening"
            }
          }
        ]
      },
      "openingHours": "Mo-Su 10:00-20:00",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "1250"
      },
      "review": [
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Priya Sharma"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5"
          },
          "reviewBody": "Excellent acne treatment at H-Cura Jayanagar. Professional staff and great results."
        },
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Rajesh Kumar"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5"
          },
          "reviewBody": "Best skin treatment in Chennai Tambaram. Highly recommend H-Cura clinic."
        },
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Meera Nair"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5"
          },
          "reviewBody": "Amazing acne treatment results at H-Cura Pondicherry. Professional and caring staff."
        }
      ]
    };

    // Update the metaKeywords content to include all areas
   
    // Update the metaDescription to include all major areas
   

    // Update document title to include more areas
    document.title =
      "Best Acne Treatment Chennai Bangalore Pondicherry | Skin Clinic Tamil Nadu Karnataka - H-Cura Multispecialty";

    // Continue with the rest of the component...
    // [Previous useEffect code for SEO setup continues here]

    // Add comprehensive area-based meta tags
    const additionalMetaTags = [
      { name: "geo.region", content: "IN-TN" },
      { name: "geo.region", content: "IN-KA" },
      { name: "geo.region", content: "IN-PY" },
      { name: "geo.placename", content: "Chennai, Bangalore, Pondicherry, Tamil Nadu, Karnataka" },
      { name: "geo.position", content: "13.0827;80.2707" }, // Chennai coordinates
      { name: "geo.position", content: "12.9716;77.5946" }, // Bangalore coordinates
      { name: "geo.position", content: "11.9416;79.8083" }, // Pondicherry coordinates
      { name: "ICBM", content: "13.0827, 80.2707" },
      { name: "ICBM", content: "12.9716, 77.5946" },
      { name: "ICBM", content: "11.9416, 79.8083" },
      { property: "og:title", content: "Best Acne Treatment Chennai Bangalore Pondicherry | H-Cura Multispecialty Clinic" },
      { property: "og:description", content: "Advanced acne treatment and skin care solutions in Chennai Tamil Nadu, Bangalore Karnataka, and Pondicherry. Professional dermatological services for clear, healthy skin at H-Cura clinics across 100+ locations." },
      { property: "og:url", content: "https://www.h-cura.com/advanced-acne-treatment" },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "en_IN" },
      { property: "og:site_name", content: "H-Cura Multispecialty Clinic" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Best Acne Treatment Chennai Bangalore Pondicherry | H-Cura" },
      { name: "twitter:description", content: "Advanced acne treatment and skin care solutions in Chennai Tamil Nadu, Bangalore Karnataka, and Pondicherry." },
      { name: "robots", content: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" },
      { name: "googlebot", content: "index, follow" },
      { name: "bingbot", content: "index, follow" },
      { name: "language", content: "English" },
      { name: "distribution", content: "global" },
      { name: "rating", content: "general" },
      { name: "revisit-after", content: "7 days" },
      { name: "author", content: "H-Cura Multispecialty Clinic" },
      { name: "classification", content: "Medical, Healthcare, Dermatology" },
      { name: "coverage", content: "Worldwide" },
      { name: "subject", content: "Acne Treatment, Skin Care, Dermatology" },
      { name: "copyright", content: "H-Cura Multispecialty Clinic" },
      { name: "locality", content: "Chennai, Bangalore, Pondicherry" },
      { name: "region", content: "Tamil Nadu, Karnataka, Pondicherry" },
      { name: "country", content: "India" }
    ];

    additionalMetaTags.forEach(tag => {
      const existingTag = document.querySelector(`meta[${tag.name ? 'name' : 'property'}="${tag.name || tag.property}"]`);
      if (existingTag) {
        existingTag.setAttribute("content", tag.content);
      } else {
        const metaTag = document.createElement("meta");
        if (tag.name) metaTag.setAttribute("name", tag.name);
        if (tag.property) metaTag.setAttribute("property", tag.property);
        metaTag.setAttribute("content", tag.content);
        document.head.appendChild(metaTag);
      }
    });

    // Add comprehensive hreflang tags for regional targeting
  

   

    // Add comprehensive preconnect and dns-prefetch for performance
    const performanceLinks = [
      { rel: "preconnect", href: "https://fonts.googleapis.com" },
      { rel: "preconnect", href: "https://fonts.gstatic.com", crossorigin: "" },
      { rel: "preconnect", href: "https://images.unsplash.com" },
      { rel: "dns-prefetch", href: "https://www.google-analytics.com" },
      { rel: "dns-prefetch", href: "https://www.googletagmanager.com" },
      { rel: "dns-prefetch", href: "https://maps.googleapis.com" },
      { rel: "dns-prefetch", href: "https://fonts.googleapis.com" },
      { rel: "dns-prefetch", href: "https://cdnjs.cloudflare.com" }
    ];

    performanceLinks.forEach(link => {
      const existingLink = document.querySelector(`link[href="${link.href}"]`);
      if (!existingLink) {
        const linkElement = document.createElement("link");
        linkElement.setAttribute("rel", link.rel);
        linkElement.setAttribute("href", link.href);
        if (link.crossorigin !== undefined) {
          linkElement.setAttribute("crossorigin", link.crossorigin);
        }
        document.head.appendChild(linkElement);
      }
    });

    // Add comprehensive sitemap and robots meta
    const sitemapLink = document.querySelector("link[rel='sitemap']");
    if (!sitemapLink) {
      const sitemap = document.createElement("link");
      sitemap.setAttribute("rel", "sitemap");
      sitemap.setAttribute("type", "application/xml");
      sitemap.setAttribute("href", "https://www.h-cura.com/sitemap.xml");
      document.head.appendChild(sitemap);
    }

    // Add breadcrumb structured data
    const breadcrumbData = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://www.h-cura.com"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Treatments",
          "item": "https://www.h-cura.com/treatments"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "Acne Treatment",
          "item": "https://www.h-cura.com/advanced-acne-treatment"
        }
      ]
    };

    const breadcrumbScript = document.createElement('script');
    breadcrumbScript.type = 'application/ld+json';
    breadcrumbScript.textContent = JSON.stringify(breadcrumbData);
    document.head.appendChild(breadcrumbScript);

    // Add FAQ structured data
    const faqData = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What areas does H-Cura serve for acne treatment?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "H-Cura provides acne treatment services across Chennai Tamil Nadu (100+ areas including Tambaram, Valasaravakkam, T Nagar, Anna Nagar), Bangalore Karnataka (100+ areas including Jayanagar, Koramangala, BTM Layout, Indiranagar), and Pondicherry (50+ areas including White Town, Lawspet, Auroville)."
          }
        },
        {
          "@type": "Question",
          "name": "What types of acne treatments are available?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We offer Advanced Hydrafacial, Professional Acne Treatment, PRP Face Therapy, CO2 Facial, Anti-Aging Laser Treatment, Skin Brightening, and Acne Scar Treatment across all our Chennai, Bangalore, and Pondicherry locations."
          }
        },
        {
          "@type": "Question",
          "name": "How can I book an appointment for acne treatment?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "You can book an appointment by calling +91 88700 01377 or visiting any of our clinics in Chennai (Tambaram, Valasaravakkam, Gerugambakkam), Bangalore (Jayanagar), or Pondicherry locations. We are open Monday to Sunday: 10:00 AM - 8:00 PM."
          }
        }
      ]
    };

    const faqScript = document.createElement('script');
    faqScript.type = 'application/ld+json';
    faqScript.textContent = JSON.stringify(faqData);
    document.head.appendChild(faqScript);

    // Continue with the rest of the component implementation...
    // [Rest of the component code continues as before]



    // Add structured data script
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);

    // Set canonical link
    const existingCanonical = document.querySelector("link[rel='canonical']");
    if (existingCanonical) {
      existingCanonical.setAttribute(
        "href",
        "https://www.h-cura.com/advanced-acne-treatment"
      );
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute(
        "href",
        "https://www.h-cura.com/advanced-acne-treatment"
      );
      document.head.appendChild(canonicalLink);
    }

    // Add additional meta tags for local SEO
    const metaTags = [
      { name: "geo.region", content: "IN-TN" },
      { name: "geo.region", content: "IN-KA" },
      { name: "geo.placename", content: "Chennai, Bangalore, Tamil Nadu, Karnataka" },
      { name: "geo.position", content: "13.0827;80.2707" }, // Chennai coordinates
      { name: "geo.position", content: "12.9716;77.5946" }, // Bangalore coordinates
      { name: "ICBM", content: "13.0827, 80.2707" },
      { name: "ICBM", content: "12.9716, 77.5946" },
      { property: "og:title", content: "Best Acne Treatment in Chennai, Bangalore | H-Cura Multispecialty Clinic" },
      { property: "og:description", content: "Advanced acne treatment and skin care solutions in Chennai Tamil Nadu and Bangalore Karnataka. Professional dermatological services for clear, healthy skin at H-Cura clinics." },
      { property: "og:url", content: "https://www.h-cura.com/advanced-acne-treatment" },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "en_IN" },
      { property: "og:site_name", content: "H-Cura Multispecialty Clinic" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Best Acne Treatment in Chennai, Bangalore | H-Cura" },
      { name: "twitter:description", content: "Advanced acne treatment and skin care solutions in Chennai Tamil Nadu and Bangalore Karnataka." },
      { name: "robots", content: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" },
      { name: "googlebot", content: "index, follow" },
      { name: "bingbot", content: "index, follow" },
      { name: "language", content: "English" },
      { name: "distribution", content: "global" },
      { name: "rating", content: "general" },
      { name: "revisit-after", content: "7 days" },
      { name: "author", content: "H-Cura Multispecialty Clinic" },
      { name: "classification", content: "Medical, Healthcare, Dermatology" },
      { name: "coverage", content: "Worldwide" },
      { name: "subject", content: "Acne Treatment, Skin Care, Dermatology" },
      { name: "copyright", content: "H-Cura Multispecialty Clinic" }
    ];

    metaTags.forEach(tag => {
      const existingTag = document.querySelector(`meta[${tag.name ? 'name' : 'property'}="${tag.name || tag.property}"]`);
      if (existingTag) {
        existingTag.setAttribute("content", tag.content);
      } else {
        const metaTag = document.createElement("meta");
        if (tag.name) metaTag.setAttribute("name", tag.name);
        if (tag.property) metaTag.setAttribute("property", tag.property);
        metaTag.setAttribute("content", tag.content);
        document.head.appendChild(metaTag);
      }
    });

    // Add hreflang tags for regional targeting
    const hreflangTags = [
      { rel: "alternate", hreflang: "en-IN", href: "https://www.h-cura.com/advanced-acne-treatment" },
      { rel: "alternate", hreflang: "en", href: "https://www.h-cura.com/advanced-acne-treatment" }
    ];

    hreflangTags.forEach(tag => {
      const existingHreflang = document.querySelector(`link[hreflang="${tag.hreflang}"]`);
      if (!existingHreflang) {
        const hreflangLink = document.createElement("link");
        hreflangLink.setAttribute("rel", tag.rel);
        hreflangLink.setAttribute("hreflang", tag.hreflang);
        hreflangLink.setAttribute("href", tag.href);
        document.head.appendChild(hreflangLink);
      }
    });

    // Set favicon
    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }

    // Add preconnect for performance
    const preconnectLinks = [
      "https://fonts.googleapis.com",
      "https://fonts.gstatic.com",
      "https://images.unsplash.com"
    ];

    preconnectLinks.forEach(url => {
      const existingPreconnect = document.querySelector(`link[href="${url}"]`);
      if (!existingPreconnect) {
        const preconnectLink = document.createElement("link");
        preconnectLink.setAttribute("rel", "preconnect");
        preconnectLink.setAttribute("href", url);
        if (url === "https://fonts.gstatic.com") {
          preconnectLink.setAttribute("crossorigin", "");
        }
        document.head.appendChild(preconnectLink);
      }
    });

    // Cleanup function
    return () => {
      const scripts = document.querySelectorAll('script[type="application/ld+json"]');
      scripts.forEach(script => {
        if (script.textContent.includes('H-Cura Multispeciality Clinic')) {
          script.remove();
        }
      });
    };
  }, []);

  // Animation setup for process steps
  useEffect(() => {
    const steps = document.querySelectorAll(".ads-process-step");
    steps.forEach((step, index) => {
      step.style.setProperty("--index", index);
      step.style.opacity = "1";
    });
  }, []);

  const openModal = (image) => {
    const index = images.findIndex((img) => img.src === image.src);
    setCurrentImageIndex(index);
    setModalImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalImage(null);
  };

  const navigatePrevious = (e) => {
    e.stopPropagation();
    const newIndex = (currentImageIndex - 1 + images.length) % images.length;
    setCurrentImageIndex(newIndex);
    setModalImage(images[newIndex]);
  };

  const navigateNext = (e) => {
    e.stopPropagation();
    const newIndex = (currentImageIndex + 1) % images.length;
    setCurrentImageIndex(newIndex);
    setModalImage(images[newIndex]);
  };

  const navigateGalleryPrev = () => {
    if (visibleGalleryImages[0] > 0) {
      const newVisibleImages = visibleGalleryImages.map((idx) => idx - 1);
      setVisibleGalleryImages(newVisibleImages);
    }
  };

  const navigateGalleryNext = () => {
    if (
      visibleGalleryImages[visibleGalleryImages.length - 1] <
      images.length - 1
    ) {
      const newVisibleImages = visibleGalleryImages.map((idx) => idx + 1);
      setVisibleGalleryImages(newVisibleImages);
    }
  };

  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isModalOpen) return;

      if (e.key === "ArrowLeft") {
        
      } else if (e.key === "ArrowRight") {
        
      } else if (e.key === "Escape") {
        closeModal();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isModalOpen, currentImageIndex]);

  return (
    <div className="ads-wrapper">
      <TreatmentNav />
      <section
        className="ads-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${heroImage})`,
        }}
      >
        <div className="ads-hero-content">
                   <h1 className="ads-hero-title">
            Innovative Acne Solutions for Radiant Skin
          </h1>
          <p className="ads-hero-text">
            Experience cutting-edge acne therapies designed to cleanse,
            rejuvenate, and transform your skin.
          </p>
          <Link
            to="/bookconsultation"
            style={{ textDecoration: "none" }}
            className="ads-cta-button"
          >
            Book Consultation
          </Link>
        </div>
      </section>

      <section className="ads-treatment-section" id="treatments">
        <div className="ads-treatment-container">
          <div className="ads-treatment-nav">
            <h2>Revitalize Your Skin with Acne</h2>
            <p className="ads-nav-description">
              Our Acne treatment combines advanced technology with nourishing
              ingredients for optimal skin health.
            </p>

            <ul className="ads-treatment-list">
              <li className="ads-treatment-item">
                <strong>HYDRAFACIAL</strong>
                <p>Thoroughly cleanses and purifies your skin.</p>
                <ul className="ads-treatment-details">
                  <li>Improves Skin Texture and Tone</li>
                  <li>Reduces Fine Lines and Wrinkles</li>
                  <li>minimized pores and make glowing skin</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>ACNE TREATMENT</strong>
                <p>Gently exfoliates to reveal smoother skin.</p>
                <ul className="ads-treatment-details">
                  <li>Improves Skin appearance & balance oil control</li>
                  <li>reduced inflammation , prevent scarring</li>
                  <li>Treats Acne and Blackheads</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>PRP FACE </strong>
                <p>Stimulates collagen production</p>
                <ul className="ads-treatment-details">
                  <li>reduced fine lines & wrinkles</li>
                  <li>Safe for all Skin</li>
                  <li>treats hyperpigmentation</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong> CO2 FACIAL</strong>
                <p>Improves acne scars & spots</p>
                <ul className="ads-treatment-details">
                  <li>stimulates collagen production</li>
                  <li>Hydration and Brightness</li>
                  <li>Improves Skin Texture and Tone</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong> LASER HAIR REMOVAL</strong>
                <p>Infuses skin with essential moisture.</p>
                <ul className="ads-treatment-details">
                  <li>Long-lasting hair removal</li>
                  <li>Quick and safe removal of hair</li>
                  <li>Ability to treat larger areas of the body</li>
                </ul>
              </li>
            </ul>

            <p className="ads-treatment-description-text">
              Our Acne treatments are customized for each individual's skin type
              and concerns.
            </p>
            <p className="ads-treatment-extra-info">
              Book a consultation today to discover the benefits of Acne
              treatment.
            </p>
          </div>

          <div className="ads-treatment-content">
            <h3>Innovative Acne Treatment </h3>
            <div className="ads-treatment-info">
              <div className="ads-treatment-images">
                <img
                  src={heroImage1}
                  alt="Innovative Acne Treatment Process"
                  className="ads-main-treatment-image"
                />
                <div className="ads-gallery-container">
                  <button 
                    className="ads-gallery-nav ads-gallery-prev ads-small-screen-nav"
                    onClick={(e) => {
                      e.preventDefault();
                      const gallery = document.querySelector('.ads-treatment-gallery');
                      if (gallery) {
                        gallery.scrollBy({ left: -gallery.clientWidth * 0.8, behavior: 'smooth' });
                      }
                      navigateGalleryPrev();
                    }}
                    aria-label="Previous image"
                    style={{
                      display: visibleGalleryImages[0] > 0 ? "block" : "none",
                    }}
                  >
                    &#10094;
                  </button>
                  <button 
                    className="ads-gallery-nav ads-gallery-next ads-small-screen-nav"
                    onClick={(e) => {
                      e.preventDefault();
                      const gallery = document.querySelector('.ads-treatment-gallery');
                      if (gallery) {
                        gallery.scrollBy({ left: gallery.clientWidth * 0.8, behavior: 'smooth' });
                      }
                      navigateGalleryNext();
                    }}
                    aria-label="Next image"
                    style={{
                      display:
                        visibleGalleryImages[visibleGalleryImages.length - 1] <
                        images.length - 1
                          ? "block"
                          : "none",
                    }}
                  >
                    &#10095;
                  </button>
                </div>

                <div className="ads-gallery-dots">
                  {images.map((_, index) => (
                    <span
                      key={index}
                      className={`ads-gallery-dot ${
                        visibleGalleryImages.includes(index) ? "active" : ""
                      }`}
                      onClick={() => {
                        const start = Math.max(0, index - 1);
                        const end = Math.min(images.length - 1, index + 1);
                        const newVisible = [];
                        for (let i = start; i <= end; i++) {
                          newVisible.push(i);
                        }
                        setVisibleGalleryImages(newVisible);
                      }}
                    ></span>
                  ))}
                </div>
              </div>

              <div className="ads-treatment-description">
                <h4>Empowering Innovative Acne Solutions</h4>
                <div className="ads-treatment-intro">
                  <span className="ads-highlight-tag">INNOVATIVE ACNE</span>
                  <p className="ads-lead-text">
                    Our breakthrough treatments combine deep cleansing, advanced
                    exfoliation, and targeted therapies to renew your skin.
                  </p>
                </div>

                <div className="ads-key-benefits">
                  <h5>Transformative Benefits of Our Treatments</h5>
                  <p>Enjoy benefits such as:</p>
                  <ul>
                    <li>
                      <span className="ads-benefit-icon">
                        <img src={nonInvasiveIcon} alt="Deep Cleansing" />
                      </span>{" "}
                      <strong>Deep Cleansing</strong>
                      <p>Improves Skin appearance & balance oil control </p>
                    </li>
                    <li>
                      <span className="ads-benefit-icon">
                        <img
                          src={enhancedHydrationIcon}
                          alt="Enhanced Hydration"
                        />
                      </span>{" "}
                      <strong>Anti scarring</strong>
                      <p>reduced inflammation , prevent scarring </p>
                    </li>
                    <li>
                      <span className="ads-benefit-icon">
                        <img
                          src={skinRenewalIcon}
                          alt="Promotes Skin Renewal"
                        />
                      </span>{" "}
                      <strong>Control excessive oil production</strong>
                      <p>Treats Acne and Blackheads </p>
                    </li>
                    <li>
                      <span className="ads-benefit-icon">
                        <img
                          src={deepCleansingIcon}
                          alt="Non-Invasive Treatment"
                        />
                      </span>{" "}
                      <strong>Non-Invasive Treatment</strong>
                      <p>
                        Achieve noticeable results without any downtime or
                        discomfort.
                      </p>
                    </li>
                  </ul>
                </div>

                <div className="ads-treatment-highlights">
                  <div className="ads-highlight-box">
                    <h5>Client Satisfaction Rate</h5>
                    <p>98%</p>
                    <span className="ads-subtitle">Happy Clients</span>
                  </div>
                  <div className="ads-highlight-box">
                    <h5>Session Duration</h5>
                    <p>45 mins</p>
                    <span className="ads-subtitle">Per Treatment</span>
                  </div>
                  <div className="ads-highlight-box">
                    <h5>Minimal Downtime</h5>
                    <p>Immediate Results</p>
                    <span className="ads-subtitle">Quick Recovery</span>
                  </div>
                </div>

                <Link to="/bookconsultation" style={{ textDecoration: "none" }}>
                  <button className="ads-book-treatment-btn">
                    Schedule Your Consultation
                    <span className="ads-btn-icon">→</span>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ads-benefits-section">
        <div className="ads-benefits-header">
          <span className="ads-section-tag">Why Choose Us</span>
          <h2>Experience Excellence with H-Cura Multispeciality clinic</h2>
          <p className="ads-section-subtitle">
            Our advanced treatments combine clinical expertise with innovative
            technology to restore your skin's natural beauty.
          </p>
        </div>
        <div className="ads-benefits-grid">
          {[
            {
              icon: "🔬",
              title: "State-of-the-Art Technology",
              desc: "We deploy the latest in acne treatment technology for precise and effective results.",
              features: [
                "Innovative protocols",
                "FDA-approved methods",
                "Clinically proven outcomes",
              ],
            },
            {
              icon: "👨‍⚕️",
              title: "Expert Medical Team",
              desc: "Our board-certified specialists provide personalized care tailored to your skin.",
              features: [
                "Highly experienced professionals",
                "Individual consultations",
                "Focused attention to detail",
              ],
            },
            {
              icon: "🎯",
              title: "Customized Therapy",
              desc: "Every treatment plan is designed specifically for your skin type and concerns.",
              features: [
                "Tailored sessions",
                "Ongoing progress monitoring",
                "Optimized treatment frequency",
              ],
            },
            {
              icon: "✨",
              title: "Natural-Looking Results",
              desc: "Achieve visible, natural skin improvement with our gentle, effective treatments.",
              features: [
                "Subtle enhancements",
                "Long-lasting benefits",
                "Effortless aesthetics",
              ],
            },
            {
              icon: "🛡️",
              title: "Safety First",
              desc: "We maintain the highest standards of safety and hygiene in our treatment facilities.",
              features: [
                "Medical-grade environment",
                "Strict protocols",
                "Patient-centric care",
              ],
            },
            {
              icon: "💯",
              title: "Proven Success",
              desc: "Join thousands of happy clients who have transformed their skin with our solutions.",
              features: [
                "Over 5000 satisfied clients",
                "Remarkable clinical outcomes",
                "Consistently high success rates",
              ],
            },
          ].map((benefit, index) => (
            <div className="ads-benefit-card" key={index}>
              <div className="ads-benefit-icon">{benefit.icon}</div>
              <div className="ads-benefit-content">
                <h3>{benefit.title}</h3>
                <p>{benefit.desc}</p>
                <ul className="ads-feature-list">
                  {benefit.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="ads-process-section" id="process">
        <div className="ads-process-header">
          <span className="ads-process-tag">Our Process</span>
          <h2>Your Journey to Radiant, Clear Skin</h2>
          <p className="ads-process-subtitle">
            Follow our comprehensive 4-step approach for sustainable skin
            rejuvenation.
          </p>
        </div>
        <div className="ads-process-timeline">
          {[
            {
              step: "01",
              title: "In-Depth Consultation",
              desc: "Kick off your journey with a thorough consultation to assess your skin and needs.",
              details: [
                "Detailed skin analysis",
                "Personal health review",
                "Customized treatment roadmap",
                "Expectation setting",
              ],
              icon: "🔍",
            },
            {
              step: "02",
              title: "Tailored Treatment Planning",
              desc: "Our specialists design a personalized acne treatment plan just for you.",
              details: [
                "Individualized regimen design",
                "Session scheduling",
                "Lifestyle coaching",
              ],
              icon: "📋",
            },
            {
              step: "03",
              title: "Expert Acne Session",
              desc: "Experience our precise techniques for targeted and effective acne treatment.",
              details: [
                "Sterile preparation",
                "Precise application",
                "Targeted skin care",
                "Comfort-focused procedure",
              ],
              icon: "💉",
            },
            {
              step: "04",
              title: "Comprehensive Aftercare",
              desc: "Benefit from our dedicated follow-up care ensuring your skin remains at its best.",
              details: [
                "Routine progress reviews",
                "Adaptive treatment adjustments",
                "Maintenance plans",
                "Long-term support",
              ],
              icon: "📈",
            },
          ].map((process, index) => (
            <div className="ads-process-step" key={index}>
              <div className="ads-step-container">
                <div className="ads-step-number-container">
                  <div className="ads-step-number">{process.step}</div>
                  <div className="ads-step-icon">{process.icon}</div>
                </div>
                <div className="ads-step-content">
                  <h3>{process.title}</h3>
                  <p className="ads-step-description">{process.desc}</p>
                  <ul className="ads-step-details">
                    {process.details.map((detail, idx) => (
                      <li key={idx}>{detail}</li>
                    ))}
                  </ul>
                </div>
              </div>
              {index < 3 && <div className="ads-connector-line"></div>}
            </div>
          ))}
        </div>
      </section>

      {/* Hidden SEO Content - Not visible to users but crawlable by search engines */}
      <div style={{ display: 'none' }}>
        <h2>Best Acne Treatment Services in Chennai Tamil Nadu and Bangalore Karnataka - H-Cura Locations</h2>
        
        <h3>Acne Treatment in Tambaram Chennai - Gandhi Road Location</h3>
        <p>
          Advanced acne treatment services at our Tambaram clinic located at Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram, Chennai, Tamil Nadu 600045. 
          Serving patients from Chromepet, Pallavaram, Perungalathur areas with PRP Hair Treatment, Dental Fillings, Acne & Skin Lightening, Root Canal and Smile Design. 
          Specializing in Hair Restoration & Dental Procedures. Contact: +91 88700 01377. Open Monday to Sunday: 10:00 AM - 8:00 PM.
          Best acne treatment Tamil Nadu, skin specialist Chennai, dermatologist Tambaram, acne clinic Chromepet, skin treatment Pallavaram, facial treatment Perungalathur.
        </p>
        
        <h3>Skin Treatment Clinic in Valasaravakkam Chennai - Krishnamachari Nagar</h3>
        <p>
          Professional skin care services at our Valasaravakkam branch located at 48, 1st Main Rd, Krishnamachari Nagar, Valasaravakkam, Chennai, Tamil Nadu 600116. 
          Serving Porur, Alwarthirunagar, Virugambakkam communities with Braces and Orthodontics, GFC Hair Therapy, Pigmentation & Skin Whitening, Anxiety & PCOS Homeopathy Treatment. 
          Specializing in Skin Treatments & Women's Health. Phone: +91 88700 01377. Hours: Monday to Sunday: 10:00 AM - 8:00 PM.
          Acne treatment Valasaravakkam, skin clinic Porur, dermatologist Alwarthirunagar, acne specialist Virugambakkam, skin care Chennai Tamil Nadu.
        </p>
        
        <h3>Complete Healthcare Solutions in Gerugambakkam Chennai - Ramachandra Nagar</h3>
        <p>
          Comprehensive medical services at our Gerugambakkam clinic at Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony, Gerugambakkam, Chennai, Tamil Nadu 600128. 
          Providing services to Kundrathur, Mangadu, Poonamallee residents with Hair Loss Treatment, Skin Problem Solutions, Complete Dental Care, Natural Homeopathy Treatment. 
          Offering Complete Healthcare Solutions. Call: +91 88700 01377. Timing: Monday to Sunday: 10:00 AM - 8:00 PM.
          Skin treatment Gerugambakkam, acne clinic Kundrathur, dermatologist Mangadu, skin specialist Poonamallee, acne treatment Chennai Tamil Nadu.
        </p>

        <h3>Advanced Skin Treatment in Jayanagar Bangalore Karnataka</h3>
        <p>
          Premier acne and skin treatment services at our Jayanagar Bangalore clinic located at Jayanagar, Bengaluru, Karnataka 560069. 
          Serving patients from Koramangala, BTM Layout, JP Nagar, Banashankari, Basavanagudi, Wilson Garden, Lalbagh areas with Advanced Acne Treatment, Hydrafacial Therapy, Anti-Aging Solutions, Laser Hair Removal. 
          Specializing in Advanced Skin & Dermatology Treatments. Contact: +91 88700 01377. Open Monday to Sunday: 10:00 AM - 8:00 PM.
          Best acne treatment Bangalore, skin specialist Karnataka, dermatologist Jayanagar, acne clinic Koramangala, skin treatment BTM Layout, facial treatment JP Nagar, 
          acne doctor Banashankari, skin care Basavanagudi, dermatology Wilson Garden, acne treatment Lalbagh, skin clinic Bangalore Karnataka, acne specialist Bengaluru.
        </p>

        <h3>Comprehensive Bangalore Karnataka Service Areas</h3>
        <p>
          H-Cura Multispeciality Clinic Bangalore provides acne treatment and skin care services across Bangalore Karnataka including Jayanagar, Koramangala, BTM Layout, JP Nagar, 
          Banashankari, Basavanagudi, Wilson Garden, Lalbagh, Indiranagar, Whitefield, Electronic City, HSR Layout, Marathahalli, Bannerghatta Road, Hebbal, Yeshwantpur,
          Rajajinagar, Malleshwaram, Sadashivanagar, RT Nagar, Yelahanka, Kengeri, Vijayanagar, Nagarbhavi areas in Karnataka.
          Acne treatment Bangalore, skin treatment Karnataka, dermatologist Bengaluru, acne clinic Bangalore, skin specialist Karnataka, facial treatment Bangalore, 
          laser treatment Karnataka, hydrafacial Bangalore, PRP treatment Karnataka, CO2 facial Bangalore, anti-aging treatment Karnataka.
        </p>

        <h3>Chennai Tamil Nadu Service Areas Coverage</h3>
        <p>
          H-Cura Multispeciality Clinic Chennai provides acne treatment and skin care services across Chennai Tamil Nadu including Tambaram East, Tambaram West, Chromepet, Pallavaram, 
          Perungalathur, Selaiyur, Chitlapakkam, Valasaravakkam, Porur, Alwarthirunagar, Virugambakkam, Ramapuram, Mugalivakkam, Gerugambakkam, Kundrathur, 
          Mangadu, Poonamallee, Nazarethpet, Thirumazhisai areas in Tamil Nadu.
          Acne treatment Chennai, skin treatment Tamil Nadu, dermatologist Chennai, acne clinic Tamil Nadu, skin specialist Chennai, facial treatment Tamil Nadu.
        </p>

        <h3>Advanced Treatments Available Across Chennai Tamil Nadu and Bangalore Karnataka</h3>
        <p>
          Our Chennai Tamil Nadu and Bangalore Karnataka locations offer comprehensive acne treatment including Advanced Hydrafacial, Professional Acne Treatment, Anti-Aging Solutions, 
          Youth Enhancement Treatments, PRP Face Therapy, CO2 Facial Procedures, Acne Scar Treatment, Mole & Birth Mark Removal, Skin Brightening, 
          Tattoo Removal, Warts Removal, Anti-Aging Laser Treatment, and Laser Hair Removal services.
          Best acne treatment Chennai Bangalore, skin specialist Tamil Nadu Karnataka, dermatologist Chennai Bangalore, acne clinic Tamil Nadu Karnataka.
        </p>

        <h3>Expert Dermatology Team Chennai Tamil Nadu Bangalore Karnataka</h3>
        <p>
          Board-certified dermatologists and skin specialists providing personalized acne treatment solutions across Tambaram Gandhi Road Chennai, 
          Valasaravakkam Krishnamachari Nagar Chennai, Gerugambakkam Ramachandra Nagar Chennai, and Jayanagar Bangalore locations in Tamil Nadu and Karnataka.
          Acne specialist Chennai Bangalore, skin doctor Tamil Nadu Karnataka, dermatologist Chennai Bangalore, acne treatment expert Tamil Nadu Karnataka.
        </p>

        <h3>SEO Keywords for Google Ranking</h3>
        <p>
          acne treatment near me, skin treatment near me, dermatologist near me, acne clinic near me, skin specialist near me, best acne treatment, 
          professional skin care, acne doctor, skin clinic, dermatology clinic, facial treatment, laser treatment, hydrafacial, PRP treatment, 
          CO2 facial, anti-aging treatment, skin brightening, acne scar treatment, pimple treatment, blackhead treatment, skin rejuvenation, 
          cosmetic dermatology, medical skincare, skin health, acne consultation, skin analysis, acne prevention, dermatological treatment, 
          skin wellness, acne therapy, skin problem solutions, acne removal, skin lightening, pigmentation treatment, skin whitening, 
          acne specialist doctor, professional acne care, advanced skin treatment, innovative acne solutions, skin transformation, 
          clear skin treatment, radiant skin therapy, skin renewal, acne management, oil control treatment, deep cleansing facial, 
          non-invasive skin treatment, safe acne treatment, effective skin care, proven acne solutions, personalized skin treatment, 
          customized acne therapy, expert skin care, quality dermatology services, trusted skin clinic, reliable acne treatment, 
          affordable skin care, convenient dermatology, accessible acne treatment, comprehensive skin solutions.
        </p>
      </div>

      {/* Modal for Image Viewing with Navigation */}
      {isModalOpen && (
        <div className="ads-modal-overlay" onClick={closeModal}>
          <div
            className="ads-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="ads-close-modal" onClick={closeModal}>
              &times;
            </button>
            <button
              className="ads-modal-nav ads-modal-prev"
              onClick={navigatePrevious}
            >
              &#10094;
            </button>
            <img
              src={modalImage.src}
              alt={modalImage.alt}
              className="ads-modal-image"
            />
            <button
              className="ads-modal-nav ads-modal-next"
              onClick={navigateNext}
            >
              &#10095;
            </button>
            <div className="ads-modal-counter">
              {currentImageIndex + 1} / {images.length}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Acne;

